import BlackBox3 from "../../assets/jpeg/ProductsAvailable/BlackBox3.jpeg";
import Treble from "../../assets/jpeg/treble.jpeg";
import A1 from "../../assets/jpeg/ProductsAvailable/A1.jpeg";
import A2 from "../../assets/jpeg/ProductsAvailable/A2.jpeg";
import A3 from "../../assets/jpeg/ProductsAvailable/A3.jpeg";
import DA from "../../assets/jpeg/ProductsAvailable/DonagerA.jpeg";
import DB from "../../assets/jpeg/ProductsAvailable/DonagerB.jpeg";
import color2 from "../../assets/jpeg/ProductsAvailable/color2.jpeg";
import color3 from "../../assets/jpeg/ProductsAvailable/color3.jpeg";
import color4 from "../../assets/jpeg/ProductsAvailable/color4.jpeg";
import bg1 from "../../assets/jpeg/ProductsAvailable/bg1.jpeg";
import bg2 from "../../assets/jpeg/ProductsAvailable/bg2.jpeg";
import wine from "../../assets/jpeg/ProductsAvailable/wine.jpg";
import people from "../../assets/jpeg/ProductsAvailable/people.jpg";
import { PRICES } from "../../config/prices";
import { N1_FROM_PRICE } from "../../config/n1";
import { N1_STUDIO, N1_LIFESTYLE } from "../N1/images";

export const ProductsAvailable = {
  Blackbox: {
    image: wine,
    image2: people,
    image3: BlackBox3,
    image5: color2,
    image6: color3,
    image7: color4,

    treble: Treble,
    title: "Blackbox",
    description:
      "Portable speaker delivering powerful sound in a compact design.",
    specifications: [
      "Power Output: 60W (AC Power) / 30W (Battery Mode)",
      "Battery Life: Up to 6.5 hours",
      "Materials: Natural wood, eco 3D-printed shell, natural foam",
      "Weight: 3kg",
      "Controls: Bass, Treble, Volume",
    ],
    price: PRICES.Blackbox,
    id: "blackbox",
  },

  Donager: {
    image3: DA,
    image: DB,
    image4: bg1,
    image5: bg2,
    treble: Treble,
    title: "Donager",
    description:
      "Built for artists and musicians who demand high-performance audio.",
    specifications: ["200W RMS", "10kg", "18hr Battery Life"],
    price: PRICES.Donager,
    id: "donager",
  },

  /* Quoted, not sold through the cart: the card links to its own page. */
  N1: {
    image: N1_STUDIO[3].src,
    image2: N1_STUDIO[0].src,
    image3: N1_LIFESTYLE[3].src,
    image4: N1_LIFESTYLE[0].src,
    title: "N1",
    description:
      "Two-way installation loudspeaker built for cafés, bars, restaurants, venues and cinema halls.",
    specifications: [
      '8", 12" or 15" — 300 to 2000W RMS',
      "Passive, or active with a Hypex amplifier",
      "Grille and side panels in your colours",
      "Chain, stand, bracket or custom mount",
    ],
    price: N1_FROM_PRICE,
    pricePrefix: "From",
    priceNote: "excl. VAT",
    link: "/shop/n1",
    id: "n1",
  },

  Aurora: {
    image: A1,
    image2: A2,
    image3: A3,
    treble: Treble,
    title: "Aurora",
    description:
      "A 60W speaker with an immersive LED light show for a full audiovisual experience.",
    specifications: [
      "60W Class D Amplifier",
      "LED Light Show",
      "Black Manta Fabric & 3D-Printed Shell (75% Natural Friendly)",
      "Bluetooth 5.0 Wireless",
      "Built-In Equalizer",
    ],
    price: PRICES.Aurora,
    id: "aurora",
  },
};
